"use strict";
// functions for choosing the right path
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrphanNodes = exports.getFartherEndingPath = void 0;
var simple_node_visitor_1 = require("./simple-node-visitor");
function getFartherEndingPath(startId, map) {
    var knownPaths = {};
    var visitedNodes = new Set();
    var path = simple_node_visitor_1.getNodePathToTarget(startId, function (n) { return n.type === "ending"; }, map, knownPaths, visitedNodes);
    var pathWithoutEndingStep = path == null ? path : path.slice(0, -1);
    return [
        pathWithoutEndingStep == null ? Infinity : pathWithoutEndingStep.length,
        visitedNodes,
        pathWithoutEndingStep,
    ];
}
exports.getFartherEndingPath = getFartherEndingPath;
function getOrphanNodes(map, visitedNodes) {
    var allNodes = new Set(Object.keys(map));
    var orphanNodes = Array.from(allNodes).filter(function (id) { return !visitedNodes.has(id); });
    return new Set(orphanNodes);
}
exports.getOrphanNodes = getOrphanNodes;
